export const CONTENT_TYPE_TEXT = 'text';
export const CONTENT_TYPE_INTERNAL_LINK = 'internal-link';
export const CONTENT_TYPE_EXTERNAL_LINK = 'external-link';
export const CONTENT_TYPE_MAIL_LINK = 'mail-link';
export const CONTENT_CONTACT_LINK = 'contact-link';
export const CONTENT_TYPE_IMAGE = 'image';
export const CONTENT_TYPE_YOUTUBE = 'youtube';

export const CONTENT_CATEGORY_ACCESS = 'ACCESS';
export const CONTENT_CATEGORY_CLIENT = 'CLIENT';
export const CONTENT_CATEGORY_SUBCONTRACTOR = 'SUBCONTRACTOR';
export const CONTENT_CATEGORY_PROJECT = 'PROJECT';
export const CONTENT_CATEGORY_OPTION = 'OPTION';
export const CONTENT_CATEGORY_PARAMETER = 'PARAMETER';
export const CONTENT_CATEGORY_DOCUMENT = 'DOCUMENT';
export const CONTENT_CATEGORY_MODEL = 'MODEL';
